
export type ReportRefVersore = {
  nrrel?: number;
  ditta?: number;
  nomeditta?: string;
  codprog?: string;
  desprog?: string;
  codcli?: number;
  ragsoccli?: string;
  tipoprog?: string;
  statoprog?: string;
  coddip?: string;
  nomedip?: string;
  codatt?: string;
  desatt?: string;
  codnodo?: string;
  desnodo?: string;
  oreord?: number;
  note?: string;
  datains?: Date | null;
  datareg?: Date | null;
  tiponodo?: string;
  prezzo?: number;
  fatt?: string;
  opzfatt?: string;
  nrfatt?: number;
  annofatt?: number;
  imprigo?: number;
  codart?: string;
  codagente?: string;
  nomeagente?: string;
  ref?: string;
};

export type ReportRefVersoreApiResponse = {
  results: Array<ReportRefVersore>;
  count: number;
};

export function mapJsonToReportRefVersoreApiResponse(jsonData: any): ReportRefVersoreApiResponse {
  const mappedData: ReportRefVersoreApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      nrrel: item.VBT52_NRREL,
      ditta: item.VBT52_DITTA,
      nomeditta: item.VBT52_NOMEDITTA,
      codprog: item.VBT52_CODPROG,
      desprog: item.VBT52_DESPROG,
      codcli: item.VBT52_CODCLI,
      ragsoccli: item.VBT52_RAGSOCCLI,
      tipoprog: item.VBT52_TIPOPROG,
      statoprog: item.VBT52_STATOPROG,
      coddip: item.VBT52_CODDIP,
      nomedip: item.VBT52_NOMEDIP,
      codatt: item.VBT52_CODATT,
      desatt: item.VBT52_DESATT,
      codnodo: item.VBT52_CODNODO,
      desnodo: item.VBT52_DESNODO,
      oreord: item.VBT52_OREORD,
      note: item.VBT52_NOTE,
      datains: item.VBT52_DATAINS,
      datareg: item.VBT52_DATAREG,
      tiponodo: item.VBT52_TIPONODO,
      prezzo: item.VBT52_PREZZO,
      fatt: item.VBT52_FATT,
      opzfatt: item.VBT52_OPZFATT,
      nrfatt: item.VBT52_NRFATT,
      annofatt: item.VBT52_ANNOFATT,
      imprigo: item.VBT52_IMPRIGO,
      codart: item.VBT52_CODART,
      codagente: item.VBT52_CODAGENTE,
      nomeagente: item.VBT52_NOMEAGENTE,
      ref: item.VBT52_REF,
    })),
  };

  return mappedData;
}




export type EmailForm = {
    email :string;
    subject :string;
    // message :string;
    attachment :string;
    tipo :string;
  };


export type ReportDateForm = {
                fromDate?     :Date;
                toDate?      :Date;
                emailTo?      :string;
  };





